export const CUSTOM_ICON_REGISTRY = {
  parking: { url: '/assets/icons/svg/parking.svg' },
  pending: { url: '/assets/icons/svg/pending.svg' },
  temperature: { url: '/assets/icons/svg/temperature.svg' },
  moving: { url: '/assets/icons/svg/moving.svg' },
  moving_2: { url: '/assets/icons/svg/moving_2.svg' },
  '403': { url: '/assets/icons/svg/403.svg' },
  '404': { url: '/assets/icons/svg/404.svg' },
  '500': { url: '/assets/icons/svg/500.svg' },
  ac: { url: '/assets/icons/svg/ac.svg' },
  trash_can: { url: '/assets/icons/svg/trash-can.svg' },
  add: { url: '/assets/icons/svg/add.svg' },
  wipers: { url: '/assets/icons/svg/wipers.svg' },
  alerts: { url: '/assets/icons/svg/alerts.svg' },
  battery_level: { url: '/assets/icons/svg/battery-level.svg' },
  charging: { url: '/assets/icons/svg/charging.svg' },
  charging_2: { url: '/assets/icons/svg/charging_2.svg' },
  trunk: { url: '/assets/icons/svg/trunk.svg' },
  defrost: { url: '/assets/icons/svg/defrost.svg' },
  flash: { url: '/assets/icons/svg/flash.svg' },
  horn: { url: '/assets/icons/svg/horn.svg' },
  check: { url: '/assets/icons/svg/import_check.svg' },
  wifi: { url: '/assets/icons/svg/wifi.svg' },
  lock: { url: '/assets/icons/svg/lock.svg' },
  unlock: { url: '/assets/icons/svg/unlock.svg' },
  map_pointer: { url: '/assets/icons/svg/map_pointer.svg' },
  upload: { url: '/assets/icons/svg/upload.svg' },
  moon: { url: '/assets/icons/svg/moon.svg' },
  online: { url: '/assets/icons/svg/online.svg' },
  zeva_navigation: { url: '/assets/icons/svg/navigation.svg' },
  search: { url: '/assets/icons/svg/search.svg' },
  calendar: { url: '/assets/icons/svg/calendar.svg' },
  notification: { url: '/assets/icons/svg/notification.svg' },
  pause: { url: '/assets/icons/svg/paused.svg' },
  check_circle: { url: '/assets/icons/svg/check.svg' },
  flag: { url: '/assets/icons/svg/flag.svg' },
  no_data: { url: '/assets/icons/svg/no-data.svg' },
  odometer: { url: '/assets/icons/svg/odometer.svg' },
  caution: { url: '/assets/icons/svg/caution.svg' },
  checkmark: { url: '/assets/icons/svg/check-mark-circle.svg' },
  'checkmark-filled': { url: '/assets/icons/svg/green-checkmark-circle.svg' },
  error_outline: { url: '/assets/icons/svg/error.svg' },
  diamond: { url: '/assets/icons/svg/diamond-stone.svg' },
  arrow_up_outline: { url: '/assets/icons/svg/arrow-up-outline.svg' },
  arrow_down_outline: { url: '/assets/icons/svg/arrow-down-outline.svg' },
  world: { url: '/assets/icons/svg/world.svg' },
  'charge-limit': { url: '/assets/icons/svg/charge-limit.svg' },
  'charge-limit-white': { url: '/assets/icons/svg/charge-limit-white.svg' },
  // climate-keeper-off: { url: '/assets/icons/svg/' },
  'climate-keeper': { url: '/assets/icons/svg/climate-keeper.svg' },
  'climate-keeper-dog': { url: '/assets/icons/svg/climate-keeper-dog.svg' },
  'climate-keeper-camp': { url: '/assets/icons/svg/climate-keeper-camp.svg' },
  'climate-keeper-keep': { url: '/assets/icons/svg/climate-keeper-keep.svg' },
  preconditioning: { url: '/assets/icons/svg/preconditioning.svg' },
  'overheat-protection': { url: '/assets/icons/svg/overheat-protection.svg' },
  recenter: { url: '/assets/icons/svg/recenter.svg' },
  expand: { url: '/assets/icons/svg/expand.svg' },
  'expand-dark': { url: '/assets/icons/svg/expand-dark.svg' },
  collapse: { url: '/assets/icons/svg/collapse.svg' },
  'wind-normal': { url: '/assets/icons/svg/wind-normal.svg' },
  'wind-warning': { url: '/assets/icons/svg/wind-warning.svg' },
  'wind-danger': { url: '/assets/icons/svg/wind-danger.svg' },
  'wind-direction': { url: '/assets/icons/svg/wind-direction.svg' },
  'add-photo': { url: '/assets/icons/svg/add-photo.svg' },
  'person-add': { url: '/assets/icons/svg/person-add.svg' },
  cancel: { url: '/assets/icons/svg/cancel.svg' },
  'push-nav': { url: '/assets/icons/svg/push-nav.svg' },
  'see-more': { url: '/assets/icons/svg/see-more.svg' },
  security: { url: '/assets/icons/svg/security.svg' },
  zebot: { url: '/assets/icons/svg/zebot.svg' },
  send: { url: '/assets/icons/svg/send.svg' },
  protection: { url: '/assets/icons/svg/protection.svg' },
  loading: { url: '/assets/icons/svg/loading.svg' },
  document: { url: '/assets/icons/svg/document.svg' },
  // Provider icons
  tesla: { url: '/assets/providers/icons/Tesla.svg' },
  smartcar: { url: '/assets/providers/icons/Smartcar.svg' },
  volvo: { url: '/assets/providers/icons/Volvo.svg' },
};
